/**
 * Load an image URL and resolve whether it is portrait or landscape.
 * Square images count as portrait (width > height → landscape).
 * @param {string} url
 * @returns {Promise<'portrait' | 'landscape'>}
 */
export function getImageOrientation(url) {
  const trimmed = String(url || '').trim();
  if (!trimmed) return Promise.resolve('portrait');

  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      const w = img.naturalWidth || 0;
      const h = img.naturalHeight || 0;
      resolve(w > h ? 'landscape' : 'portrait');
    };
    img.onerror = () => resolve('portrait');
    img.src = trimmed;
  });
}
